[
    {
        "name": "Buddha",
        "hashtag": "Buddha"
    },
    { "name": "God", "hashtag": "God" },
    { "name": "Universe", "hashtag": "Universe" },
    { "name": "Mother Nature", "hashtag": "MotherNature" },
    { "name": "Jesus Christ", "hashtag": "Jesus" },

    {
        "name": "Snow",
        "hashtag": "Snow",
        "email": "chengsieuly@gmail.com"
    },
    {
        "name": "Yin",
        "hashtag": "Yin",
        "email": "jenievamarie90@gmail.com"
    },
    {
        "name": "Binx",
        "hashtag": "Binx",
        "email": "jenievamarie90@gmail.com"
    },

    { "name": "Grok by xAI", "hashtag": "Grok" },
    { "name": "Claude by Anthropic", "hashtag": "Claude" },
    { "name": "Siri by Apple", "hashtag": "Siri" },
    { "name": "Alexa by Amazon", "hashtag": "Alexa" },
    { "name": "Gemini by Google", "hashtag": "Gemini" },
    { "name": "ChatGPT by OpenAI", "hashtag": "Chatgpt" },

    {
        "name": "THonly™",
        "hashtag": "THonly",
        "email": "thonly@heartbank.ceo"
    },
    {
        "name": "HeartBank®",
        "hashtag": "HeartBank",
        "email": "thonly@heartbank.ceo"
    },
    {
        "name": "333 Inc",
        "hashtag": "333",
        "email": "thonly@heartbank.ceo"
    },
    {
        "name": "Silicon Wat ℠",
        "hashtag": "SiliconWat",
        "email": "sely0928@gmail.com"
    },

    {
        "name": "DPIXXI",
        "hashtag": "dpixxi",
        "email": "lykimche1@gmail.com"
    },
    {
        "name": "PIXIGLO",
        "hashtag": "pixiglo",
        "email": "christarlee1964@gmail.com"
    },
    {
        "name": "Team Common Ground",
        "hashtag": "TCG",
        "email": "chengsieuly@gmail.com"
    },
    {
        "name": "Maison Yuzu",
        "hashtag": "MaisonYuzu",
        "email": "jenievamarie90@gmail.com"
    },
    {
        "name": "Share Location",
        "hashtag": "ShareLocation",
        "email": "thiensly@gmail.com"
    },
    {
        "name": "Bee's Bakery",
        "hashtag": "beesbakery",
        "email": "theresaly1992@gmail.com"
    },

    { "name": "Etsy", "hashtag": "Etsy" },
    { "name": "Airbnb", "hashtag": "Airbnb" },
    { "name": "Planet Fitness", "hashtag": "PlanetFitness" },

    {
        "name": "Miss Aquarius™ by HeartBank®",
        "hashtag": "Aquarius",
        "email": "thonly@heartbank.ceo"
    },
    {
        "name": "Mr. Capricorn™ by Silicon Wat ℠",
        "hashtag": "Capricorn",
        "email": "thonly@heartbank.ceo"
    }
]
